// components/dashboard/user/Wallet.jsx
import { Link } from "react-router-dom";
import { useState } from "react";
import './Wallet.scss'; 
import HeaderOne from "../../../HeaderOne";
import Breadcrumb from "../../../Breadcrumb";

const Wallet = () => {
  const [amount, setAmount] = useState(1000);
  const [selectedAmount, setSelectedAmount] = useState(null);

  const quickAmounts = [500, 1000, 1500];

  const handleAmountSelect = (value) => {
    setAmount(value);
    setSelectedAmount(value);
  };

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
    setSelectedAmount(null);
  };

  return (
    <>
    <HeaderOne/>

    {/* Breadcrumb */}
    <Breadcrumb />
    
    <div className="wallet-container">
      {/* Main Wallet Interface */}
      <div className="wallet-header">
        <h1>My Wallet</h1>
        
        <div className="balance-section">
          <div className="balance-info">
            <div className="total-balance">
              <h2>Total balance</h2>
              <p className="balance-amount">₹0.00</p>
            </div>
            
            <div className="balance-breakdown">
              <div className="balance-item">
                <span className="label">Wallet</span>
                <span className="amount">₹0.00</span>
              </div>
              <div className="balance-item">
                <span className="label">Gift Cards</span>
                <span className="amount">₹0.00</span>
              </div>
            </div>
          </div>

          <div className="quick-actions">
            <h3>Do More with My Wallet</h3>
            <div className="action-list">
              <Link to="claim" className="action-item">
                <span className="action-text">Claim Gift Voucher</span>
                <span className="action-arrow">›</span>
              </Link>
              <Link to="create" className="action-item">
                <span className="action-text">Create Gift Voucher</span>
                <span className="action-arrow">›</span>
              </Link>
              <Link to="history" className="action-item">
                <span className="action-text">Transaction history</span>
                <span className="action-arrow">›</span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Add Money Section */}
      <div className="add-money-section">
        <h2>Add money to Wallet</h2>
        
        <div className="amount-input-section">
          <div className="input-wrapper">
            <span className="currency-symbol">₹</span>
            <input
              type="number"
              className="amount-input"
              placeholder="Enter Amount"
              value={amount}
              onChange={handleAmountChange}
            />
          </div>
        </div>

        <div className="quick-amounts">
          {quickAmounts.map((value) => (
            <button
              key={value}
              className={`amount-btn ${selectedAmount === value ? 'active' : ''}`}
              onClick={() => handleAmountSelect(value)}
            >
              + ₹{value}
            </button>
          ))}
        </div>

        <div className="limit-info">
          <div className="info-icon">i</div>
          <span>You can add up to ₹10000.00</span>
        </div>

        <button className="setup-wallet-btn">
          Set-up wallet to add money
        </button>
      </div>
    </div>
    </>
  );
};

export default Wallet;